/* eslint-disable spaced-comment */
/// <reference types="react-scripts" />
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "ui/Scripts/source/framework/base";
import Logo from "./../../../../Content/devel/images/logo.png";

export interface ILoginPageProp {
    onLogin: (username: string, password: string) => void;
    onLogout: () => void;
}

export interface ILoginPageState {
    username: string;
    password: string;
    submitted: boolean;
    returnUrl: string;
}

export class LoginPage extends React.Component<ILoginPageProp, ILoginPageState> {
    constructor(props) {
        super(props);
        this.props.onLogout();
        this.state = { username: "", password: "", submitted: false, returnUrl: window.location.href };
    }

    handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const state = this.state;
        this.setState({ submitted: true });
        if (!Base.isNullOrEmpty(state.username) && !Base.isNullOrEmpty(state.password)) {
            this.props.onLogin(state.username, state.password);
        }
    };

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "username") {
            this.setState({ username: value });
        } else if (name === "password") {
            this.setState({ password: value });
        }
    };

    render() {
        return (
            <div className="Absolute-Center is-Responsive loginForm">
                <img className="loginLogo img-responsive" src={Logo} />
                <div className="loginContainer">
                    <form name="loginForm" onSubmit={this.handleSubmit}>
                        <div className="form-group">
                            <input className="form-control" id="UserName" name="username" placeholder={Translations.UserName} value={this.state.username} type="text" autoComplete="username" onChange={this.handleChange}/>
                        </div>
                        <div className="form-group">
                            <input className="form-control" name="password" placeholder={Translations.Password} value={this.state.password} type="password" autoComplete="current-password" onChange={this.handleChange}/>
                        </div>
                        <div className="form-group text-center">
                            <input className="btn btn-default loginButton" type="submit" value={Translations.LogIn} />
                        </div>
                        {!!appConfig.forgotPasswordUrlTemplate &&
                            <div className="form-group">
                                <div style={{ display: "flex", marginTop: "10px" }}>
                                    <a href={String.format(appConfig.forgotPasswordUrlTemplate, Base.base64UrlEncode(this.state.returnUrl))} style={{ marginLeft: "auto", marginRight: "auto" }}>{Translations.IHaveForgotMyPassword}</a>
                                </div>
                            </div>
                        }
                    </form>
                </div>
            </div>
        );
    }
}